import { render, staticRenderFns } from "./ItserveLanguagePicker.vue?vue&type=template&id=07450214&scoped=true&"
import script from "./ItserveLanguagePicker.vue?vue&type=script&lang=js&"
export * from "./ItserveLanguagePicker.vue?vue&type=script&lang=js&"
import style0 from "./ItserveLanguagePicker.vue?vue&type=style&index=0&id=07450214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07450214",
  null
  
)

export default component.exports